module.exports = __webpack_public_path__ + "img/title-bg.ecabba00.png";